<template>
  <div class="selector">
    <div class="label merchant-filter">
      <h4 class="selector-name">{{ shopName }}</h4>
      <p class="selector-code">{{ shopCode }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShopDisplayFixed',
  props: {
    shopName: {
      type: String,
      default: ''
    },
    shopCode: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="scss">
.selector {
  flex-shrink: 0;
  background-color: #415468;
  border-radius: 8px;
  color: $solidWhite;
  width: 350px;
  height: 45.6px;
}

.selector-code {
  color: #8a8a8a;
  font-size: 0.75em;
  line-height: 1;
}

.selector-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 270px;
  font-size: 1em;
  line-height: 1.1;
  font-family: 'Rubik-Light';
}

.merchant-filter {
    padding: 8px 40px 8px 8px !important;
    text-align: left;
    letter-spacing: 0px;
}
</style>
